import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { SidebarMenuItem } from "./SidebarMenuItem";
import { TransformedPermission } from "../../../../../app/type_interface/SettingType";
import {
	MainRouteType,
	SubRouteType,
	mainRoutesConfig,
	subRoutesConfig,
	RouteType,
} from "../../../../../app/modules/auth/AuthMenu";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { getRolePermission, getMyModuleNames } from "../../../../../app/services/settingServices";
import { getEmpId, getRoleId } from "../../../../../app/helpers/appHelpers";
import { Module } from "../../../../../app/type_interface/SettingType";
import { useMasterData } from "../../../../../app/context/MasterDataContext";
import { useAlertModal } from "../../../../../app/context/ModalContext";

const SidebarMenuMain = () => {
	const { masterData, setPermissionList, setActionList } = useMasterData();
	const { openAlertModal } = useAlertModal();
	const [isMenuLoading, setIsMenuLoading] = useState<boolean>(false);
	const [isError, setIsError] = useState<boolean>(false);
	const { permissionList } = masterData;

	const { pathname } = useLocation();
	const [expandedKey, setExpandedKey] = useState<string | null>(null);

	useEffect(() => {
		setExpandedKey(null);
	}, [pathname]);

	//PERMISSION TEMPLATE
	const [dashboardPermission, setDashboardPermission] = useState<TransformedPermission>();
	const [currentMapPermission, setCurrentMapPermission] = useState<TransformedPermission>();
	const [currentDeliveryPermission, setCurrentDeliveryPermission] =
		useState<TransformedPermission>();

	// const getPermission = async () => {
	//   const adminPermissions = await getModulePermissions("DASHBOARD", "DASHBOARD_MAIN");
	//   setDashboardPermission(adminPermissions);
	// };

	// useEffect(() => {
	//   getPermission()
	// }, [dashboardPermission])

	// const intl = useIntl()

	const fetchPermissionList = async () => {
		setIsMenuLoading(true);
		try {
			const [permResult, moduleResult] = await Promise.all([
				getRolePermission(getRoleId()),
				getMyModuleNames(),
			]);

			// Build lookup: module_code -> { name, sort_order }
			const nameLookup: Record<string, { name: string; sort_order: number }> = {};
			if (moduleResult && moduleResult.success && moduleResult.data) {
				for (const mod of moduleResult.data as Module[]) {
					nameLookup[mod.module_code] = { name: mod.module_name, sort_order: mod.sort_order };
					for (const sub of mod.sub_modules) {
						nameLookup[sub.module_code] = { name: sub.module_name, sort_order: sub.sort_order };
					}
				}
			}

			if (permResult && permResult.success) {
				// New compact format: ['ROLE_MANAGEMENT.view', 'ROLE_MANAGEMENT.edit', ...]
				const permArray = permResult.data as string[];

				// Build map: { MODULE_CODE: ['view', 'edit', ...] }
				const permMap: Record<string, string[]> = {};
				for (const entry of permArray) {
					const dotIdx = entry.lastIndexOf(".");
					if (dotIdx === -1) continue;
					const code = entry.substring(0, dotIdx);
					const method = entry.substring(dotIdx + 1);
					if (!permMap[code]) permMap[code] = [];
					permMap[code].push(method);
				}

				const userMainRoute: MainRouteType[] = [];
				const actionList: RouteType[] = [];

				for (const mainRoute of mainRoutesConfig) {
					const subMenus: SubRouteType[] = subRoutesConfig
						.filter(
							(sub) =>
								sub.main_module_code === mainRoute.module_code &&
								(permMap[sub.module_code]?.length ?? 0) > 0,
						)
						.map((sub) => ({
							...sub,
							title: nameLookup[sub.module_code]?.name ?? sub.module_code,
							permission: permMap[sub.module_code],
						}))
						.sort((a, b) => {
							const aOrder = nameLookup[a.module_code]?.sort_order ?? 999;
							const bOrder = nameLookup[b.module_code]?.sort_order ?? 999;
							return aOrder - bOrder;
						});

					if (subMenus.length > 0) {
						actionList.push(...subMenus);
						userMainRoute.push({
							...mainRoute,
							title: nameLookup[mainRoute.module_code]?.name ?? mainRoute.module_code,
							subMenu: subMenus,
						});
					}
				}

				// Sort main menu items by backend sort_order
				userMainRoute.sort((a, b) => {
					const aOrder = nameLookup[a.module_code]?.sort_order ?? 999;
					const bOrder = nameLookup[b.module_code]?.sort_order ?? 999;
					return aOrder - bOrder;
				});

				setPermissionList(userMainRoute);
				setActionList(actionList);
			} else {
				setIsError(true);
				throw new Error("getRolePermission returns error.");
			}
		} catch (e) {
			console.error(e);
			console.log("fetchPermissionList returns error.");
			setPermissionList([]); // Release waiting components like DashboardPage
		} finally {
			setIsMenuLoading(false);
		}
	};

	useEffect(() => {
		fetchPermissionList();
	}, [masterData.updatePermission]);

	// ------------------------ อย่าเพิ่ม PATH ตรงนี้ หรือถ้าเพิ่มเพื่อเทส icon อย่าลืมลบก่อน PUSH ด้วยนะครับบบบบบ ------------------------
	// ------------------------------------------------ จาก DEV ผู้อดหลับอดนอน -----------------------------------------------

	return (
		<>
			{isMenuLoading ? (
				<div className="menu-item">
					<div className="menu-content pt-8 pb-2">
						<span className="menu-section text-muted text-uppercase fs-8 ls-1">Loading....</span>
					</div>
				</div>
			) : isError ? (
				<div className="menu-item">
					<div className="menu-content pt-8 pb-2">
						<span className="menu-section text-muted text-uppercase fs-8 ls-1">
							An error occurs while loading.
						</span>
					</div>
				</div>
			) : (
				<React.Fragment>
					{dashboardPermission?.view && (
						// <SidebarMenuItem to='/dashboard' icon='element-11' title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} fontIcon='bi-app-indicator' />
						<SidebarMenuItem
							to="/dashboard"
							icon="element-11"
							title={"Dashboard"}
							fontIcon="bi-app-indicator"
						/>
					)}
					{currentMapPermission?.view && (
						<SidebarMenuItem
							to="/current_map"
							icon="eye"
							title={"ติดตามรถ"}
							fontIcon="bi-app-indicator"
						/>
					)}
					{currentDeliveryPermission?.view && (
						<SidebarMenuItem
							to="/dashboard_delivery_location"
							icon="map"
							title={"ติตตามการจัดส่ง"}
							fontIcon="bi-app-indicator"
						/>
					)}
					{/* <SidebarMenuItem to='/work_plans' icon='switch' title='แผนงาน' fontIcon='bi-layers' /> */}

					<div className="menu-item">
						<div className="menu-content pt-8 pb-2">
							<span className="menu-section text-muted text-uppercase fs-8 ls-1">Menu</span>
						</div>
					</div>

					{permissionList.map((menu, index) => {
						return (
							<SidebarMenuItemWithSub
								key={`${menu.module_code}-${index}`}
								to={menu.path}
								title={menu.title}
								fontIcon={menu.fontIcon}
								icon={menu.icon}
								isManuallyExpanded={expandedKey === menu.path}
								anyManuallyExpanded={expandedKey !== null}
								onToggle={() =>
									setExpandedKey((prev) => (prev === menu.path ? null : menu.path))
								}
							>
								{menu.subMenu.map((sub, subIndex) => (
									<SidebarMenuItem
										key={`${sub.module_code}-${subIndex}`}
										to={sub.path}
										title={sub.title}
										hasBullet={true}
									/>
								))}
							</SidebarMenuItemWithSub>
						);
					})}
				</React.Fragment>
			)}
		</>
	);
};

export { SidebarMenuMain };
